import type { ResourceLanguage } from 'i18next'

import account from './account.json'
import alerts from './alerts.json'
import asyncUpdates from './asyncUpdates.json'
import auth from './auth.json'
import automations from './automations.json'
import campaigns from './campaigns.json'
import cogs from './cogs.json'
import common from './common.json'
import dashboards from './dashboards.json'
import distributionAnalysis from './distributionAnalysis.json'
import filters from './filters.json'
import metrics from './metrics.json'
import navigation from './navigation.json'
import segments from './segments.json'
import table from './table.json'

const zh: ResourceLanguage = {
    account,
    alerts,
    auth,
    asyncUpdates,
    automations,
    campaigns,
    cogs,
    common,
    dashboards,
    distributionAnalysis,
    filters,
    metrics,
    navigation,
    segments,
    table,
}

export default zh
